import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { Loader2, Shield } from 'lucide-react';
export function RequireAdminAuth({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const [status, setStatus] = useState<'loading' | 'authenticated' | 'unauthenticated'>('loading');
  useEffect(() => {
    let cancelled = false;
    async function checkSession() {
      console.log('[RequireAdminAuth] Checking session for:', location.pathname);
      const {
        data: {
          session
        },
        error
      } = await supabase.auth.getSession();
      if (cancelled) return;
      console.log('[RequireAdminAuth] Session result:', {
        pathname: location.pathname,
        hasSession: !!session,
        hasAccessToken: !!session?.access_token,
        userId: session?.user?.id ?? null,
        error: error?.message ?? null
      });
      if (session?.access_token) {
        setStatus('authenticated');
      } else {
        console.log('[RequireAdminAuth] No valid session — redirecting to /admin/login from:', location.pathname);
        setStatus('unauthenticated');
      }
    }
    checkSession();
    const {
      data: {
        subscription
      }
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.access_token) {
        setStatus('authenticated');
      } else {
        setStatus('unauthenticated');
      }
    });
    return () => {
      cancelled = true;
      subscription.unsubscribe();
    };
  }, [location.pathname]);
  if (status === 'loading') {
    return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center" data-id="element-739">
        <div className="text-center space-y-4" data-id="element-740">
          <div className="w-16 h-16 bg-[#141414] border border-white/10 rounded-2xl flex items-center justify-center mx-auto" data-id="element-741">
            <Shield className="w-8 h-8 text-[#006847]" data-id="element-742" />
          </div>
          <Loader2 className="w-6 h-6 text-[#006847] animate-spin mx-auto" data-id="element-743" />
          <p className="text-white/40 text-sm" data-id="element-744">Verificando sesión...</p>
        </div>
      </div>;
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/admin/login" state={{
      from: location.pathname
    }} replace data-id="element-745" />;
  }
  return <>{children}</>;
}